import React from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';
import { Header } from '../components/Header';
import { Section } from '../components/Section';

export const CheckoutSFRErrorPage: React.FC = () => {
  return (
    <UI>
      <Header title="Cash Flow Error" />
      <Section title="Investment Amount" description="Please enter the amount you would like to invest."></Section>
    </UI>
  );
};
